<div class="p-grid" id="mu-auth-person-billing">
  <h2 class="mu-layout-auth-sub-title p-col-12">{{ 'context.accountData.step' | translate: { step: 2 } }}</h2>
  <h1 class="mu-layout-auth-title p-col-12" translate="context.accountData.titleBilling"></h1>
  <div class="p-col-12 mu-without-padding">
    <app-auth-company-billing-form
      [loader]="flagList.get(companyBillingFlags.ACTION)"
      [formData]="formData"
      [cityList]="cityList"
      [documentTypeList]="documentTypeList"
      [segmentationList]="segmentationList"
      [isMX]="isMX"
      [actionList]="actionList"
      [registerAction]="actionListEnum.REGISTER"
    ></app-auth-company-billing-form>
  </div>
</div>
